module.exports = __webpack_public_path__ + "static/media/ring.a41d8aa3.jpg";